(function(){
  'use strict';

  // Pre-fill full cart widget (my-delivery-widget) from localStorage
  // Runs on every page load — safe because it checks !_kPlz.value first
  try {
    var _saved = localStorage.getItem('mfl_plz') || '';
    var _kPlz  = document.getElementById('mdw-kurier-plz');
    var _dPlz  = document.getElementById('mdw-dpd-plz');
    if (_kPlz && !_kPlz.value && _saved.length === 5) {
      _kPlz.value = _saved;
      _kPlz.dispatchEvent(new Event('input', { bubbles: true }));
    }
    if (_dPlz && !_dPlz.value && _saved.length === 5) {
      _dPlz.value = _saved;
    }
  } catch(e){}

  var root = document.getElementById('mdwc');
  if (!root) return; // Not on product page — compact widget done

  // Guard against double-init using DOM attribute (survives SPA navigation resets)
  if (root.getAttribute('data-mdwc-init')) return;
  root.setAttribute('data-mdwc-init', '1');

  var S_ok      = root.getAttribute('data-s-ok')       || '';
  var S_bad     = root.getAttribute('data-s-bad')      || '';
  var S_hint    = root.getAttribute('data-s-hint')     || '';
  var S_far     = root.getAttribute('data-s-far')      || '';
  var S_far_hint= root.getAttribute('data-s-far-hint') || '';
  var S_far_cta = root.getAttribute('data-s-far-cta')  || '';
  var S_range   = root.getAttribute('data-s-range')    || '';

  var PLZ_ZONES = {
    '80999':0,
    '81247':1,'80997':1,'81245':1,'80993':1,'80995':1,'81243':1,'80992':1,
    '80638':2,'81241':2,'81249':2,'80809':2,'80639':2,'80689':2,'80637':2,
    '80687':2,'80634':2,'80935':2,'80807':2,'80796':2,'80804':2,'80797':2,
    '80933':2,'80803':2,'80798':2,'80686':2,'80636':2,'80801':2,'80799':2,
    '80333':3,'80339':3,'80802':3,'80335':3,'81373':3,'80539':3,'80336':3,'80538':3,
    '80805':3,'80331':3,'80337':3,'81675':3,'80469':3,'80937':3,'82152':3,
    '81679':3,'81375':3,'81541':3,'81667':3,'81925':3,'85716':3,'81677':3,
    '81669':3,'81377':3,'81927':3,'81539':3,'81671':3,'81547':3,
    '80939':4,'81475':4,'81673':4,'81549':4,'82349':4,'81545':4,'81379':4,
    '81369':4,'81371':4,'81737':4,'81735':4,'81477':4,'82131':4,'81543':4,
    '81739':4,'81479':4,
    '82031':5,'85579':5,'82008':5,'85609':5,'82049':5,'82319':5,'85551':5,
    '81929':5,'85622':5,'85586':5,'85540':5
  };
  // Versandkosten rechnet Shopify Local Delivery (per Distanz vom Shop). Wir prüfen nur
  // ob die PLZ im Liefergebiet liegt — die Spanne 0–39€ wird als Hinweis angezeigt.
  var PLZ_FAR = {
    '81829':1,'82343':1,'85598':1,'82065':1,'82335':1,'81827':1,
    '82340':1,'81825':1,'82346':1,'82327':1,'85521':1,'82024':1,'82041':1,
    '82054':1,'82362':1,'82064':1,'82402':1,'82377':1
  };

  function getEl(id){ return document.getElementById(id); }

  function check(val){
    var rEl   = getEl('mdwc-result');
    var iEl   = getEl('mdwc-result-icon');
    var tEl   = getEl('mdwc-result-text');
    var pEl   = getEl('mdwc-result-price');
    var waBtn = getEl('mdwc-wa-btn');
    var waLbl = getEl('mdwc-wa-label');
    if (!rEl) return;

    var methods = root.querySelectorAll('.mdwc-method');
    function highlight(name){ methods.forEach(function(m){ m.classList.toggle('on', m.getAttribute('data-m') === name); }); }
    function hideWa(){ if (waBtn) waBtn.style.display = 'none'; }
    function showWa(){ if (waLbl) waLbl.textContent = S_far_cta; if (waBtn) waBtn.style.display = 'flex'; }

    if (val.length < 5){
      rEl.style.display = 'none';
      hideWa();
      methods.forEach(function(m){ m.classList.remove('on'); });
      return;
    }
    var z = PLZ_ZONES[val];
    if (z !== undefined){
      rEl.className = 'mdwc-result ok'; rEl.style.display = 'flex';
      if (iEl) iEl.className = 'at at-check';
      if (tEl) tEl.innerHTML = '<strong>' + S_ok + '</strong> ' + S_range;
      if (pEl) pEl.textContent = '';
      hideWa(); highlight('kurier');
      try { localStorage.setItem('mfl_method','kurier'); } catch(e){}
    } else if (PLZ_FAR[val]) {
      rEl.className = 'mdwc-result far'; rEl.style.display = 'flex';
      if (iEl) iEl.className = 'at at-map-marker-al';
      if (tEl) tEl.innerHTML = '<strong>' + S_far + '</strong> ' + S_far_hint;
      if (pEl) pEl.textContent = '';
      showWa(); highlight('dpd');
      try { localStorage.setItem('mfl_method','dpd'); } catch(e){}
    } else {
      rEl.className = 'mdwc-result bad'; rEl.style.display = 'flex';
      if (iEl) iEl.className = 'at at-times-r';
      if (tEl) tEl.innerHTML = '<strong>' + S_bad + '</strong> ' + S_hint;
      if (pEl) pEl.textContent = '';
      hideWa(); highlight('dpd');
      try { localStorage.setItem('mfl_method','dpd'); } catch(e){}
    }
    try { localStorage.setItem('mfl_plz', val); } catch(e){}
    if (val.length === 5){
      try {
        fetch('/cart/update.js', {
          method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
          body: JSON.stringify({ attributes: { 'PLZ': val } })
        }).catch(function(){});
      } catch(e){}
    }
  }

  var plzInput = getEl('mdwc-plz');
  if (plzInput) {
    var _lastVal = '';
    function handlePlz() {
      var v = plzInput.value.replace(/\D/g,'').slice(0,5);
      if (v !== plzInput.value) { plzInput.value = v; }
      if (v !== _lastVal) { _lastVal = v; check(v); }
    }
    plzInput.addEventListener('input',  handlePlz);
    plzInput.addEventListener('keyup',  handlePlz);
    plzInput.addEventListener('change', handlePlz);
    // Polling fallback — catches paste, autofill, mobile edge cases
    setInterval(function(){ if (plzInput.value !== _lastVal) handlePlz(); }, 400);
    try {
      var initPlz = localStorage.getItem('mfl_plz') || '';
      if (initPlz.length === 5) {
        plzInput.value = initPlz;
        check(initPlz);
      }
    } catch(e){}
  }
})();
